import { envConfig } from './env';

export const CUSTOMER_KEY_COOKIE = 'customerKey';
export const SESSION_KEY_COOKIE = 'sessionKey';

export const VOYADO_ELEVATE_API_URL = {
    STOREFRONT: `https://${envConfig.NEXT_PUBLIC_ELEVATE_CLUSTER_ID}.api.esales.apptus.cloud/api/storefront/v3`,
    ADMIN: `https://${envConfig.NEXT_PUBLIC_ELEVATE_CLUSTER_ID}.api.esales.apptus.cloud/api/admin/v4`,
};
